import React from 'react'
import { Badge } from 'react-bootstrap'

const StatusBadge = ({ children }) => <Badge>{children.toUpperCase()}</Badge>

export default StatusBadge
